// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import ViewUI from 'view-design'
import locale from 'view-design/dist/locale/en-US';
import axios from 'axios'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import moment from 'moment-timezone';
import post from './utils/config'
import timeChange from './utils/time'
import util from './utils/util'
import isLogin from './utils/isLogin'
import language from './utils/language'
import systemValue from './utils/systemValue'
import topBar from './components/topBar'
import headDetail from './components/headDetail'
import selectOption from './components/selectOption'
import resetPwd from './components/resetPwd'
import filters from './filters'
import VueCookie from 'vue-cookie'
import 'view-design/dist/styles/iview.css'
import './assets/css/public.styl'

if(localStorage.getItem('languageType')==1){
    Vue.use(ViewUI,{locale})
}else{
    Vue.use(ViewUI)
}

filters(Vue)

Vue.use(VueQuillEditor, moment)
Vue.use(VueCookie)
Vue.component('topBar', topBar)
Vue.component('headDetail', headDetail)
Vue.component('selectOption', selectOption)
Vue.component('resetPwd', resetPwd)
window.router=router

router.beforeEach((to, from, next) => {
    ViewUI.LoadingBar.start();
    if(to.path!=='/login/1' && to.path!== '/login'){
        localStorage.setItem('preRoute',to.fullPath)
    }
    if(to.path!=='/login/1' && to.path!== '/login' && to.query.redirect){
        next({
            path: to.query.redirect,
            query: { redirect: to.fullPath }  // 'to.fullPath'跳转到登录之前页面的路径
        });
    }else{
        next()
    }
});



router.afterEach(route => {
    ViewUI.LoadingBar.finish();
});

Vue.$http = Vue.prototype.$http = axios
Vue.$post = Vue.prototype.$post = post
Vue.$timeChange = Vue.prototype.$timeChange = timeChange
Vue.$isLogin = Vue.prototype.$isLogin = isLogin
Vue.$language = Vue.prototype.$language = language
Vue.$systemValue = Vue.prototype.$systemValue = systemValue
Vue.$hasPermission = Vue.prototype.$hasPermission = util.hasPermission
Vue.$quickSort = Vue.prototype.$quickSort = util.quickSort
Vue.$keySort = Vue.prototype.$keySort = util.keySort
Vue.$cshQian = Vue.prototype.$cshQian = util.cshQian
Vue.$isMobile = Vue.prototype.$isMobile = util.isMobile
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js